import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

import Page from "../Page/Page";
import Button from "../../Components/Common/Button";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import { Transaction_ketablog } from "../../Connections/Transaction";

import "swiper/css";
import "../../Styles/KetaBlog.css";
import Faq from "react-faq-component";

const Ketablog = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const params = useParams();
  // ====================================================

  const [bottomslider, setbottomslider] = useState([]);
  const [BlogSliderhotText, setBlogSliderhotText] = useState([]);
  const [bottomCategories, setBottomSCategories] = useState([]);
  const [grouping, setGrouping] = useState([]);
  // ====================================================

  useEffect(() => {
    Transaction_ketablog.BlogSliderbottom().then((res) => {
      if (res[1] == "ok") setbottomslider(res[2].data);
    });
    Transaction_ketablog.BlogSliderhotText(params.id && params.id).then(
      (res) => {
        if (res[1] == "ok") {
          setBlogSliderhotText(res[2].data.posts);
          setBottomSCategories(res[2].data.categories);
        }
      }
    );
  }, [params.id]);
  // ====================================================
  useEffect(() => {
    setGrouping([]);
  }, []);

  // ====================================================
  const handelKetaBlog = () => {
    if (location?.state?.prevPath) {
      console.log(location?.state?.prevPath);
      navigator(location?.state?.prevPath);
    } else {
      navigator("/hisstori/blog");
    }
  };
  // ====================================================
  // console.log(BlogSliderhotText);
  // const config = {
  //   animate: true,
  //   openOnload: -1,
  // };

  // const [FAQ, setFAQ] = useState({});
  // useEffect(() => {
  //   Transaction_ketablog.BlogSliderhotText().then((res) => {
  //     if (res[1] === "ok") {
  //       const x = [];
  //       res[2].data.categories.map((item) => {
  //         x.push({
  //           title: (
  //             <div style={{ fontFamily: "inherit" }}>
  //               <span
  //                 style={{
  //                   marginLeft: "12px",
  //                   fontFamily: "inherit",
  //                 }}
  //               >
  //                 {item.title}
  //               </span>
  //             </div>
  //           ),
  //           content: (
  //             <>
  //               {item.text}
  //               <br />
  //               <br />
  //               {item.img ? (
  //                 <img src={item.img} alt="news img" className="w-100" />
  //               ) : null}
  //             </>
  //           ),
  //         });
  //       });
  //       setFAQ({ rows: x });
  //     }
  //   });
  // }, []);

  return (
    <Page>
      <MobileNavBar text={"کتابلاگ"} action={handelKetaBlog} />
      <div className="Ketablog_wrapper">
        <div onClick={() => handelKetaBlog()} className="ketablog-back-icon">
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.16984 15C1.31923 15.0005 1.46684 14.9675 1.60182 14.9035C1.7368 14.8395 1.85572 14.746 1.94984 14.63L6.77984 8.63C6.92692 8.45107 7.00732 8.22663 7.00732 7.995C7.00732 7.76338 6.92692 7.53893 6.77984 7.36L1.77984 1.36C1.6101 1.15578 1.36619 1.02736 1.10176 1.00298C0.837334 0.978601 0.574053 1.06026 0.369836 1.23C0.16562 1.39974 0.0371957 1.64365 0.012816 1.90808C-0.0115638 2.1725 0.0700977 2.43578 0.239836 2.64L4.70984 8L0.389837 13.36C0.267554 13.5068 0.189877 13.6855 0.165997 13.8751C0.142118 14.0646 0.173034 14.257 0.25509 14.4296C0.337146 14.6021 0.466906 14.7475 0.629016 14.8486C0.791127 14.9497 0.978803 15.0022 1.16984 15Z"
              fill="#ffffff"
            ></path>
          </svg>
        </div>
        {/* <div className="ketablog-topImage-conatiner mobile-hidden">
          <div className="ketablog-topImage-right">
            <img
              src="/imgs/ketablog/imagesafar.png"
              className="ketablog-topImage-right-style"
            />
            <span className="ketablog-topImage-right-spanone">
              سفر به اعماق تاریخ
            </span>
            <span className="ketablog-topImage-right-spantwo">
              سارا اسماعیلی - 11 تیر 1401
            </span>
          </div>
          <div className="ketablog-topImage-left">
            <div className="ketablog-topImage-left-child">
              <img
                src="/imgs/ketablog/imageketabno.png"
                className="ketablog-topImage-left-style"
              />
              <span className="ketablog-topImage-left-spanone">
                کتابنو چیست؟
              </span>
            </div>
            <div className="ketablog-topImage-left-child">
              <img
                src="/imgs/ketablog/imageketabno.png"
                className="ketablog-topImage-left-style"
              />
              <span className="ketablog-topImage-left-spantwo">
                کتابنو چیست؟
              </span>
            </div>
            <div className="ketablog-topImage-left-child ketablog-topImage-left-visibility">
              <img
                src="/imgs/ketablog/imageketabno.png"
                className="ketablog-topImage-left-style"
              />
              <span className="ketablog-topImage-left-spanone">
                کتابنو چیست؟
              </span>
            </div>
          </div>
        </div> */}
        <div className="ketablog-mataleb-container">
          <span className="ketablog-mataleb-spantitle">پیشنهاد کتابلاگ</span>
          <hr className="ketablog-mataleb-hr" />
          <div className="ketablog-mataleb-slider-visibility">
            {BlogSliderhotText.map((bottomslider) => (
              <div className="ketablog" key={bottomslider.id}>
                <div className="ketablog-right">
                  <p className="ketablog-right-title">{bottomslider.title}</p>
                  <img className="ketablog-right-img" src={bottomslider.pic} />
                </div>
                <div className="ketablog-left">
                  <p className="ketablog-left-text">{bottomslider.detail}</p>
                  <div className="ketablog-left-button">
                    <Button
                      text={"مطالعه بیشتر"}
                      shadowType={"inset"}
                      mobilePosition={"right"}
                      fontSize={"1vw"}
                      heightSize={"3px"}
                      link={`/hisstori/blog/keta-blog-introduce/${bottomslider.id}`}
                    />
                  </div>
                </div>
              </div>
            ))}
            {/* {BlogSliderhotText.map((bottomslider) => (
              <Swiper
                spaceBetween={20}
                slidesPerView={3}
                style={{ overflow: "inherit" }}
              >
                <SwiperSlide key={bottomslider.id}>
                  <div className="ketablog-mataleb-data">
                    <img
                      src={bottomslider.src}
                      className="ketablog-mataleb-img"
                    />
                    <span className="ketablog-mataleb-span-title">
                      {bottomslider.title}
                    </span>
                    <span className="ketablog-mataleb-span-text">
                      {bottomslider.text}
                    </span>
                    <div className="ketablog-mataleb-more">
                      <Button
                        text={"مطالعه بیشتر"}
                        shadowType={"inset"}
                        mobilePosition={"right"}
                        fontSize={"1vw"}
                        heightSize={"3px"}
                        link={"/hisstori/blog/keta-blog/1"}
                      />
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            ))} */}
          </div>
          <div className="ketablog-mataleb-slider-visibility-mobile">
            {BlogSliderhotText.map((BlogSliderhotText) => (
              <div
                className="ketablog-mataleb-slider-mobile"
                key={BlogSliderhotText.id}
              >
                <div className="ketablog-mataleb-slider-mobile-imagecontainer">
                  <img src={BlogSliderhotText.pic} />
                </div>
                <div className="ketablog-mataleb-slider-mobile-title">
                  <span>{BlogSliderhotText.title}</span>
                </div>
                <div className="ketablog-mataleb-slider-mobile-text">
                  <span>{BlogSliderhotText.text}</span>
                </div>
                <div className="ketablog-mataleb-more">
                  <Button
                    text={"مطالعه بیشتر"}
                    shadowType={"inset"}
                    mobilePosition={"right"}
                    fontSize={"12px"}
                    heightSize={"10px"}
                    link={`/hisstori/blog/keta-blog-introduce/${BlogSliderhotText.id}`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="ketablog-bottom">
          <p className="ketablog-bottom-title">دسته بندی مطالب</p>
          <div className="ketablog-bottom-grouping-border">
            <div className="ketabBlogFAQ_questions-container">
              {bottomCategories.map((item, index) => {
                return (
                  <Link to={`/hisstori/blog/keta-blog/${item.id}`}>
                    <div className="ketabBlogFAQ_questions-item">
                      <p>{item.title}</p>
                      <img src={"/imgs/arrow.svg"} alt="arrow" />
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};
export default Ketablog;
